/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponClassStudentItemViewModel } from "../types/CouponClassStudentItemViewModel.ts";

export const couponClassStudentItemViewModelSchema = z.object({
  classStudentId: z.optional(
    z.number().int().describe("ID da turma vinculada ao cupom."),
  ),
  description: z.string().describe("Descrição da turma.").nullish(),
  code: z.string().describe("Código da turma.").nullish(),
}) as unknown as ToZod<CouponClassStudentItemViewModel>;
